import React from 'react';
import { CheckIcon } from 'lucide-react';
export function IdentificacionSection() {
  const items = ['Trabajas muchas horas', 'Respondes mensajes todo el día', 'Cierras el día agotada, pero siempre "con más cosas pendientes"', 'Tu agenda está llena, pero tu facturación no cambia', 'Vas a dormir sintiendo que hiciste mucho... y que no avanzaste'];
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-88">
      <div className="max-w-4xl mx-auto" data-id="element-89">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center md:text-left" data-id="element-90">
          Esto es lo que parece crecimiento…
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-91">
          <ul className="space-y-4" data-id="element-92">
            {items.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-93">
                <CheckIcon className="w-6 h-6 text-[#D90B10] flex-shrink-0 mt-0.5" data-id="element-94" />
                <span className="text-xl text-gray-800" data-id="element-95">{item}</span>
              </li>)}
          </ul>

          <div className="space-y-4 text-xl text-gray-700 bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-96">
            <p data-id="element-97">Pero hay algo que no estás viendo:</p>
            <br data-id="element-98" />
            <p className="font-bold text-gray-900" data-id="element-99">
              no todo lo que haces hace crecer tu negocio.
            </p>
          </div>
        </div>
      </div>
    </section>;
}